import React from 'react'
import { connect } from 'react-redux';

import GenericIcon from 'components/GenericIcon'
import ContinueButton from 'components/ContinueButton'
import { updateReadyForFinalStart } from '../../../actions';

class ReadyForFinal extends React.Component {

  onContinueClick = () => {
    this.props.updateReadyForFinalStart()
  }

  render() {
    return(
      <div>
        <div className='card-single-title'>
          <h3 className='text-center'>Ready for final approval?</h3>
          <p className='text-center grey'>
            It looks like you have been granted conditional approval, and now you have found your home!
          </p>
          <p className='text-center grey'>
            We ask you to go through our application process again, but all fields you entered in the previous application will be pre-filled.
          </p>
          <p className='text-center grey'>
            This gives you the chance to change anything that may have updated (e.g. a new phone number), without you needing to re-complete the entire application again.
          </p>
        </div>
        <br />
        <div className='card card-single'>
          <div className='card-header'>
            What you will be doing
          </div>
          <ul className='list-group list-group-flush'>
            <li className='list-group-item list-group-item-lg'>
              <div className='row'>
                <div className='col-4 col-sm-2 align-self-center'>
                   <GenericIcon name='identification' />
                </div>
                <div className='col align-self-center'>
                  Verifying your identity with documentation
                </div>
              </div>
            </li>

            <li className='list-group-item list-group-item-lg'>
              <div className='row'>
                <div className='col-4 col-sm-2 align-self-center'>
                  <GenericIcon name='puzzlePiece' />
                </div>
                <div className='col align-self-center'>
                  Setting up your loan
                </div>
              </div>
            </li>

            <li className='list-group-item list-group-item-lg'>
              <div className='row'>
                <div className='col-4 col-sm-2 align-self-center'>
                   <GenericIcon name='mediumHome' />
                </div>
                <div className='col align-self-center'>
                  Providing details on the home you found
                </div>
              </div>
            </li>
          </ul>
        </div>


        <div className="text-center">
          <ContinueButton
            enabled={ true }
            onClick={ this.onContinueClick }
          />
        </div>
      </div>
    )
  }
}

export default connect(null, {
  updateReadyForFinalStart,
})(ReadyForFinal)
